import { useId, useState } from "react";
import { Aviso, Boton, Modal } from "../../components/ui/primitivos";
import { MOTIVO_MAX, MOTIVO_MIN, motivoListo } from "./acciones";

/**
 * Pide el motivo de una decisión de facturación —«No se factura», «Reabrir»—,
 * de 10 a 500 caracteres como exige el worker (ADR 0099 A4, C4). El error del
 * back se muestra adentro: un 409 («ya la resolvió otro») no cierra el diálogo
 * en silencio.
 */
export function DialogoMotivo({
  abierto,
  titulo,
  descripcion,
  confirmar,
  onCerrar,
  onConfirmar,
}: {
  abierto: boolean;
  titulo: string;
  descripcion: string;
  confirmar: string;
  onCerrar: () => void;
  onConfirmar: (motivo: string) => Promise<void>;
}) {
  const [motivo, setMotivo] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);
  const idMotivo = useId();
  const idContador = useId();
  const largo = [...motivo.trim()].length;

  function cerrar() {
    setMotivo("");
    setError(null);
    onCerrar();
  }

  return (
    <Modal abierto={abierto} onCerrar={cerrar} titulo={titulo} descripcion={descripcion}>
      <form
        className="space-y-4"
        onSubmit={async (e) => {
          e.preventDefault();
          if (!motivoListo(motivo)) return;
          setEnviando(true);
          setError(null);
          try {
            await onConfirmar(motivo.trim());
            cerrar();
          } catch (err) {
            setError(err instanceof Error ? err.message : "La acción falló");
          } finally {
            setEnviando(false);
          }
        }}
      >
        <div className="space-y-1">
          <label htmlFor={idMotivo} className="block text-neutral-600 text-sm">
            Motivo
          </label>
          <textarea
            id={idMotivo}
            rows={3}
            value={motivo}
            aria-describedby={idContador}
            onChange={(e) => setMotivo(e.target.value)}
            className="w-full rounded-md border border-neutral-300 bg-white px-3 py-2 text-neutral-900 text-sm"
          />
          <p
            id={idContador}
            className={
              largo > MOTIVO_MAX || (largo > 0 && largo < MOTIVO_MIN)
                ? "text-red-700 text-xs"
                : "text-neutral-500 text-xs"
            }
          >
            {largo}/{MOTIVO_MAX} · mínimo {MOTIVO_MIN} caracteres
          </p>
        </div>

        {error ? <Aviso>{error}</Aviso> : null}

        <div className="flex justify-end gap-2">
          <Boton variante="secundario" onClick={cerrar}>
            Volver
          </Boton>
          <Boton type="submit" disabled={!motivoListo(motivo) || enviando}>
            {confirmar}
          </Boton>
        </div>
      </form>
    </Modal>
  );
}
